import React, { useState, useEffect } from 'react';
import ListItemButton from '@mui/material/ListItemButton';
import MenuIcon from '@mui/icons-material/Menu';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import ListItemText from '@mui/material/ListItemText';
import TR from './../../Trans';
import CancelIcon from '@mui/icons-material/Cancel';
import performanceStore from '../../stores/performance';

function PerformanceSongbookListItem(props) {

  const setPerformanceToBeChanged = performanceStore((state) => state.setPerformanceToBeChanged);
  const setSongbookPerformanceToBeDeleted = performanceStore((state) => state.setSongbookPerformanceToBeDeleted);
  const removeSongbookPerformanceFromToBeDeleted = performanceStore((state) => state.removeSongbookPerformanceFromToBeDeleted);
  const songbookPerformancesToBeDeleted = performanceStore((state) => state.songbookPerformancesToBeDeleted);

  const [anchorEl, setAnchorEl] = useState(null);
  const [isMenuOpen, setMenuOpen] = useState(false);

  const handleMenuClose = () => {
    setMenuOpen(false);
  };

  const openMenu = (event) => {
    setAnchorEl(event.currentTarget);
    setMenuOpen(true);
  };

  const renderIndex = () => {
    if (props.performance && props.showIndex) {
      if (props.performance.position) {
        return (props.performance.position + 1) + ". ";
      } else {
        return "1. ";
      }
    }
    return "";
  };

  const primaryText = renderIndex() + props.performance.profile.name + " - " + props.performance.track.title;
  const secondaryText = props.performance.track.artist;

  const lengthToMinutes = (length) => {
    const splitted = length.split(":");
    if (splitted.length == 3) {
      return splitted[1] + ":" + splitted[2];
    }
  };

  const renderMenu = () => {
    if (props.isSongReq) {
      return <div>
        <IconButton
          id={"menu-songbook-button-" + props.performance.unique_id}
          color="white"
          component="label"
          size="small"
          aria-controls={isMenuOpen ? "menu-songbook-" + props.performance.unique_id : undefined}
          aria-haspopup="true"
          aria-expanded={isMenuOpen ? 'true' : undefined}
          onClick={(e) => {

            e.stopPropagation();
            openMenu(e);
          }} >
          <MenuIcon />
        </IconButton>
        <Menu disableAutoFocus disableEnforceFocus disableRestoreFocus  
          id={"menu-songbook-" + props.performance.unique_id}
          open={isMenuOpen}
          anchorEl={anchorEl}
          onClose={(e) => {

            e.stopPropagation();
            handleMenuClose();
          }}
          MenuListProps={{
            'aria-labelledby': 'menu-button-' + props.performance.unique_id,
          }}
        >
          <MenuItem onClick={(e) => {

            e.stopPropagation();
            setSongbookPerformanceToBeDeleted(props.performance)
            props.onDelete();
            handleMenuClose();
          }}>{TR.cm_delete}</MenuItem>
        </Menu>
      </div>;
    }
  };

  const performanceItem = () => {
    return <ListItemButton sx={{bgcolor: isMenuOpen ? 'rgba(255, 255, 255, 0.08)' : 'unset'}} disabled={props.isDeleted || songbookPerformancesToBeDeleted[props.performance.unique_id]} selected={props.isCurrent} onClick={() => {
      if (props.onEditPerformance && !(props.isDeleted || songbookPerformancesToBeDeleted[props.performance.unique_id])) {
        props.onEditPerformance();
      }
    }}>
      <ListItemText primary={primaryText} secondary={secondaryText} />
      <ListItemText
        className="muvika-list-right"
        primary={
          <div>
            {(props.performance.pitch != 0 ? (props.performance.pitch > 0 ? "+" : "") + props.performance.pitch + " " : "")}
            {lengthToMinutes(props.performance.track.length)}
          </div>
        }
        secondary={props.performance.track.kcode}
      />
      {renderMenu()}
    </ListItemButton>;
  };

  const changeablePerformance = () => {
    return <ListItemButton selected={true}>
      <ListItemText primary={TR.cm_select_new_song + "..."} secondary={primaryText} />
      <IconButton onClick={() => {
        setPerformanceToBeChanged(null);
      }} >
        <CancelIcon />
      </IconButton>
    </ListItemButton>;
  };

  const renderListItem = () => {
    if (props.performanceToBeChanged) {
      if (props.performanceToBeChanged.unique_id == props.performance.unique_id) {
        return changeablePerformance();
      }
    }
    return performanceItem();
  };

  return (
    <div>
      {renderListItem()}
    </div>
  );
}

export default PerformanceSongbookListItem;